package com.shadowings.gero.data.lessons.chapter8

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.shadowings.gero.data.lessons.buildVsoPhoneticKeyboardQuizzes
import com.shadowings.gero.data.lessons.buildVsoWordSelectionQuizzes
import com.shadowings.gero.data.repository.DatabaseRepositoryImpl
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.data.repository.SentenceOptions
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_soggetto_esplicito_alyn_1
import gero.composeapp.generated.resources.exp_content_soggetto_esplicito_alyn_2
import gero.composeapp.generated.resources.exp_content_soggetto_esplicito_alyn_3
import gero.composeapp.generated.resources.exp_content_soggetto_esplicito_alyn_4
import gero.composeapp.generated.resources.exp_content_soggetto_esplicito_nilo_1
import gero.composeapp.generated.resources.exp_content_soggetto_esplicito_nilo_2
import gero.composeapp.generated.resources.exp_content_soggetto_esplicito_nilo_3
import gero.composeapp.generated.resources.exp_title_soggetto_esplicito
import kotlin.random.Random

fun getSoggettoEsplicitoContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_soggetto_esplicito,
            content = Res.string.exp_content_soggetto_esplicito_nilo_1,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_soggetto_esplicito,
            content = Res.string.exp_content_soggetto_esplicito_nilo_2,
            face = Faces.Serious,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_soggetto_esplicito,
            content = Res.string.exp_content_soggetto_esplicito_alyn_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_soggetto_esplicito,
            content = Res.string.exp_content_soggetto_esplicito_alyn_2,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(word = "X1D46-I9", rtl = false, cart = false)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_soggetto_esplicito,
            content = Res.string.exp_content_soggetto_esplicito_alyn_3,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(word = "X1D46-Y3-A1", rtl = false, cart = false)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_soggetto_esplicito,
            content = Res.string.exp_content_soggetto_esplicito_nilo_3,
            face = Faces.Serious,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_soggetto_esplicito,
            content = Res.string.exp_content_soggetto_esplicito_alyn_4,
            face = Faces.Happy,
            character = Characters.Alyn,
        )
    )
}

fun getSoggettoEsplicitoQuizContent(
    hiero: List<Hiero>,
    words: List<Word>,
    verbs: List<Verb>,
    languageCode: String,
    verbSentences: List<SentenceOptions> = DatabaseRepositoryImpl.verbSentences
): List<IQuizContent> {
    val wordSelection = buildVsoWordSelectionQuizzes(
        soggettiCount = 1,
        oggettiCount = 0,
        random = Random,
        languageCode = languageCode,
        count = 8,
        verbSentences = verbSentences,
        words = words,
        verbs = verbs
    )
    val keyboardQuizzes = buildVsoPhoneticKeyboardQuizzes(
        soggettiCount = 1,
        oggettiCount = 0,
        random = Random,
        languageCode = languageCode,
        count = 2,
        verbSentences = verbSentences,
        words = words,
        verbs = verbs
    )
    return (wordSelection + keyboardQuizzes).shuffled()
}
